var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1533 20.8223H9.08799C8.43586 20.8223 7.90723 21.1908 7.90723 21.6454V23.1393H18.3341V21.6454C18.3341 21.1908 17.8054 20.8223 17.1533 20.8223Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17969 2.31641V9.81939C5.17969 13.7729 7.81495 17.2416 11.6237 18.3016H14.6766C18.4853 17.2416 21.1206 13.7729 21.1206 9.81939V2.31641H5.17969Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1504 18.998H12.1504V19.998H14.1504V18.998Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5522 8.78305C16.9207 8.42384 16.7173 7.79805 16.2081 7.72402L14.8027 7.51981C14.6005 7.49042 14.4257 7.36341 14.3352 7.18018L13.7067 5.90664C13.4789 5.44518 12.821 5.44518 12.5932 5.90664L11.9647 7.18018C11.8743 7.36341 11.6994 7.49042 11.4972 7.51981L10.0918 7.72402C9.58261 7.79805 9.37925 8.42384 9.74773 8.78305L10.7647 9.77433C10.9111 9.91695 10.9778 10.1224 10.9433 10.3239L10.7032 11.7237C10.6162 12.2309 11.1486 12.6176 11.604 12.3782L12.8611 11.7173C13.0419 11.6222 13.258 11.6222 13.4389 11.7173L14.696 12.3782C15.1514 12.6176 15.6838 12.2309 15.5968 11.7237L15.3567 10.3239C15.3221 10.1225 15.3889 9.91701 15.5352 9.77433L16.5522 8.78305Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.04 14.2974C23.4157 13.1505 25.6498 10.631 25.6498 7.80591V6.67963C25.6498 6.23956 25.2917 5.88281 24.8501 5.88281H21.1715",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25977 14.2974C2.88406 13.1505 0.65001 10.631 0.65001 7.80591V6.67963C0.65001 6.23956 1.00807 5.88281 1.44974 5.88281H5.12833",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.be4b69fed657fc3b4902650f3b1fe95b.svg";
export { ForwardRef as ReactComponent };